<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>These accounts are not in campaign.If you proceed to import this list without accounts then it will be removed from the campaign. </h5>
          <!-- <download-excel class="ml-5"
            :data="unmatched_contacts"
            :export-fields="json_fields"
            type="csv"
            name="unassociated_contacts.xls"
          >
            <vs-button icon="file_download" color="primary" type="filled">
              Export</vs-button
            >
          </download-excel> -->
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            @click="proceedToML"
            color="primary"
            type="filled"
            >Proceed</vs-button
          >
        </vs-col>
      </vs-row>

      <ClientDataGrid
      :context="'unAssociatedContactsGrid'" 
      @associatedContactWithAccount="associatedContactWithAccount"
      @UpdateAssociatedCompanyNameOfContact="UpdateAssociatedCompanyNameOfContact"
      @dropUnassociatedContacts="dropUnassociatedContacts"
      @dropUnassociatedContactsWithGroup="dropUnassociatedContactsWithGroup"
      ref="unAssociatedContactsGrid"
      :columnDefs="columnDefs"
      :rowData="unAssociatedContacts"
      :rowSelection="'single'"
    >
    </ClientDataGrid>

      <!-- AgGrid Table -->
      <!-- <DataGrid
      :rowSelection="'single'"
      :context="'unAssociatedContactsGrid'" 
        @associatedContactWithAccount="associatedContactWithAccount"
    @dropUnassociatedContacts="dropUnassociatedContacts"
        ref="unAssociatedContactsGrid"
        :columnDefs="columnDefs"
        :rowData="unAssociatedContacts"
        :dataSource="dataSource"
      >
      </DataGrid> -->
      <template>

        <vs-popup style="width:100%;"
        fullscreen
        class="text-center"
        title="Select account from master database to match."
        :active.sync="UpdateAccountpopupActive"
      >
      <div class="text-center mb-10">




      <h6 class="mb-5">Account : 
       {{ selectedCompanyContact }} </h6>

      
           
      </div>
        <div style="height:500px;">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h6>Search Company:</h6>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <AccountAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCompany"
                :searchOn="'company_or_registration_no'"
                @event-name="handleChildEvent"
              ></AccountAutocomplete>
              
            </div>
            <feather-icon
            icon="PlusIcon"
            border="rounded-full"
            svgClasses="ml-5 h-5 w-5 hover:text-danger cursor-pointer"
            @click="goToCreateAccountPage"
          />
          </div>

          <div v-if="accountDescription.length != 0">
            <div class="bg-grid-color-secondary h-12">
              <div>
                <vs-list>
                  <vs-list-header
                    title="Key Company Details"
                    color="danger"
                  ></vs-list-header>
                  <vs-list-item title="Company Name">
                    {{ accountDescription.company_name }}
                  </vs-list-item>
                  <vs-list-item title="Country">
                    {{ accountDescription.head_office_country }}
                  </vs-list-item>

                  <vs-list-item title="Switchboard">
                    <template v-for="(ph, index) in accountDescription.phone">
                      <div :key="index">
                        <template v-for="(ph_type, index2) in ph.phone_type">
                          <div
                            :key="index2"
                            v-if="
                              ph_type.type ==
                                'head_office_switchboard' &&
                                ph_type.phone_id == ph.id
                            "
                          >
                            {{ ph.phone_no }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </vs-list-item>
                  <vs-list-item title="Site Switchboard">
                    <template v-for="(ph, index) in accountDescription.phone">
                      <div :key="index">
                        <template v-for="(ph_type, index2) in ph.phone_type">
                          <div
                            :key="index2"
                            v-if="
                              ph_type.type == 'site_switchboard' &&
                                ph_type.phone_id == ph.id
                            "
                          >
                            {{ ph.phone_no }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </vs-list-item>
                  <vs-list-item
                    title="Company Registration Number"
                    v-if="accountDescription.company_registration_number"
                  >
                    {{ accountDescription.company_registration_number }}
                  </vs-list-item>
                </vs-list>

                <vs-list>
                  <vs-list-header
                    title="Address"
                    color="danger"
                  ></vs-list-header>
                  <vs-list-item title="Head Office Address">
                    {{ accountDescription.head_office_address_1 }}
                    {{ accountDescription.head_office_address_2 }}
                    {{ accountDescription.head_office_address_3 }}
                    {{ accountDescription.head_office_city }}
                    {{ accountDescription.head_office_postcode }}
                    {{ accountDescription.head_office_county }}
                    {{ accountDescription.head_office_country }}
                  </vs-list-item>
                  <vs-list-item title="Registered Office Address">
                    {{ accountDescription.registered_office_address_1 }}
                    {{ accountDescription.registered_office_address_2 }}
                    {{ accountDescription.registered_office_address_3 }}
                    {{ accountDescription.registered_office_city }}
                    {{ accountDescription.registered_office_postcode }}
                    {{ accountDescription.registered_office_county }}
                    {{ accountDescription.registered_office_country }}
                  </vs-list-item>
                  <template
                    v-for="(satellite,
                    index) in accountDescription.satellite_office"
                  >
                    <vs-list-item
                      :title="'Satellite Office ' + (index + 1)"
                      :key="index"
                    >
                      <template v-for="(phone, index3) in satellite.phone">
                        <div
                          :key="index3"
                          v-if="phone.satellite_office_id == satellite.id"
                        >
                          {{ phone.phone_no }}
                        </div>
                      </template>
                      {{ satellite.address_1 }}
                      {{ satellite.address_2 }}
                      {{ satellite.address_3 }}
                      {{ satellite.town }}
                      {{ satellite.county }}
                      {{ satellite.postcode }}
                    </vs-list-item>
                  </template>
                </vs-list>

                <vs-list>
                  <vs-list-header
                    title="Websites"
                    color="danger"
                  ></vs-list-header>
                  <template v-for="(web, index) in accountDescription.web">
                    <div :key="index">
                      {{ web.url }}
                    </div>
                  </template>
                </vs-list>
                <vs-list>
                  <vs-list-header
                    title="LinkedIn"
                    color="danger"
                  ></vs-list-header>
                  <template
                    v-for="(linkedin, index) in accountDescription.linkedin"
                  >
                    <div :key="index">
                      {{ linkedin.url }}
                    </div>
                  </template>
                  <div v-if="accountDescription.registered_office">
                    <template
                      v-for="(registered_url,
                      index) in accountDescription.registered_office"
                    >
                      <div :key="index">
                        <template
                          v-for="(reg, index1) in registered_url.linkedin"
                        >
                          <div :key="index1">
                            {{ reg.url }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div v-if="accountDescription.satellite_office">
                    <template
                      v-for="(satellite_url,
                      index) in accountDescription.satellite_office"
                    >
                      <div :key="index">
                        <template
                          v-for="(sat, index1) in satellite_url.linkedin"
                        >
                          <div :key="index1">
                            {{ sat.url }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </vs-list>
              </div>
            </div>
          </div>
        </div>
        <vs-button
          class="mt-10"
          v-if="accountDescription.length != 0"
          @click="UpdateacceptAssociation()"
          >Accept</vs-button
        >
      </vs-popup>



        <vs-popup style="width:100%;"
          fullscreen
          class="text-center"
          title="Select account from master database for this contact."
          :active.sync="popupActive"
        >
        <div class="text-center mb-10">




        <h6 class="mb-5">Account : 
          <template v-for="campaign_column in campaign_columns">



            <template v-if="campaign_column.identifier == 'company_name'">




              <template v-for="contact,value in selectedCompanyContact">

              <template v-if="campaign_column.id == value">
                {{ contact }}

            </template>



              </template>
             


            </template>



          </template> </h6>
                <h6>Contact :    <template v-for="campaign_column in campaign_columns">

                  <template v-if="campaign_column.identifier == 'forename'">
      
      
                    <template v-for="contact,value in selectedCompanyContact">
      
                    <template v-if="campaign_column.id == value">
                      {{ contact }}
      
                  </template>
      
      
      
                    </template>
                   
      
      
                  </template>
      
      
      
                </template>
              
              
                <template v-for="campaign_column in campaign_columns">

                  <template v-if="campaign_column.identifier == 'surname'">
      
      
                    <template v-for="contact,value in selectedCompanyContact">
      
                    <template v-if="campaign_column.id == value">
                      {{ contact }}
      
                  </template>
      
      
      
                    </template>
                   
      
      
                  </template>
      
      
      
                </template>
              
              
              </h6>
        </div>
          <div style="height:500px;">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h6>Search Company:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <AccountAutocomplete
                  :key="companySearchComponentKey"
                  class="searchbox"
                  :list="searchCompany"
                  :searchOn="'company_or_registration_no'"
                  @event-name="handleChildEvent"
                ></AccountAutocomplete>
              </div>
            </div>

            <div v-if="accountDescription.length != 0">
              <div class="bg-grid-color-secondary h-12">
                <div>
                  <vs-list>
                    <vs-list-header
                      title="Key Company Details"
                      color="danger"
                    ></vs-list-header>
                    <vs-list-item title="Company Name">
                      {{ accountDescription.company_name }}
                    </vs-list-item>
                    <vs-list-item title="Country">
                      {{ accountDescription.head_office_country }}
                    </vs-list-item>

                    <vs-list-item title="Switchboard">
                      <template v-for="(ph, index) in accountDescription.phone">
                        <div :key="index">
                          <template v-for="(ph_type, index2) in ph.phone_type">
                            <div
                              :key="index2"
                              v-if="
                                ph_type.type ==
                                  'head_office_switchboard' &&
                                  ph_type.phone_id == ph.id
                              "
                            >
                              {{ ph.phone_no }}
                            </div>
                          </template>
                        </div>
                      </template>
                    </vs-list-item>
                    <vs-list-item title="Site Switchboard">
                      <template v-for="(ph, index) in accountDescription.phone">
                        <div :key="index">
                          <template v-for="(ph_type, index2) in ph.phone_type">
                            <div
                              :key="index2"
                              v-if="
                                ph_type.type == 'site_switchboard' &&
                                  ph_type.phone_id == ph.id
                              "
                            >
                              {{ ph.phone_no }}
                            </div>
                          </template>
                        </div>
                      </template>
                    </vs-list-item>
                    <vs-list-item
                      title="Company Registration Number"
                      v-if="accountDescription.company_registration_number"
                    >
                      {{ accountDescription.company_registration_number }}
                    </vs-list-item>
                  </vs-list>

                  <vs-list>
                    <vs-list-header
                      title="Address"
                      color="danger"
                    ></vs-list-header>
                    <vs-list-item title="Head Office Address">
                      {{ accountDescription.head_office_address_1 }}
                      {{ accountDescription.head_office_address_2 }}
                      {{ accountDescription.head_office_address_3 }}
                      {{ accountDescription.head_office_city }}
                      {{ accountDescription.head_office_postcode }}
                      {{ accountDescription.head_office_county }}
                      {{ accountDescription.head_office_country }}
                    </vs-list-item>
                    <vs-list-item title="Registered Office Address">
                      {{ accountDescription.registered_office_address_1 }}
                      {{ accountDescription.registered_office_address_2 }}
                      {{ accountDescription.registered_office_address_3 }}
                      {{ accountDescription.registered_office_city }}
                      {{ accountDescription.registered_office_postcode }}
                      {{ accountDescription.registered_office_county }}
                      {{ accountDescription.registered_office_country }}
                    </vs-list-item>
                    <template
                      v-for="(satellite,
                      index) in accountDescription.satellite_office"
                    >
                      <vs-list-item
                        :title="'Satellite Office ' + (index + 1)"
                        :key="index"
                      >
                        <template v-for="(phone, index3) in satellite.phone">
                          <div
                            :key="index3"
                            v-if="phone.satellite_office_id == satellite.id"
                          >
                            {{ phone.phone_no }}
                          </div>
                        </template>
                        {{ satellite.address_1 }}
                        {{ satellite.address_2 }}
                        {{ satellite.address_3 }}
                        {{ satellite.town }}
                        {{ satellite.county }}
                        {{ satellite.postcode }}
                      </vs-list-item>
                    </template>
                  </vs-list>

                  <vs-list>
                    <vs-list-header
                      title="Websites"
                      color="danger"
                    ></vs-list-header>
                    <template v-for="(web, index) in accountDescription.web">
                      <div :key="index">
                        {{ web.url }}
                      </div>
                    </template>
                  </vs-list>
                  <vs-list>
                    <vs-list-header
                      title="LinkedIn"
                      color="danger"
                    ></vs-list-header>
                    <template
                      v-for="(linkedin, index) in accountDescription.linkedin"
                    >
                      <div :key="index">
                        {{ linkedin.url }}
                      </div>
                    </template>
                    <div v-if="accountDescription.registered_office">
                      <template
                        v-for="(registered_url,
                        index) in accountDescription.registered_office"
                      >
                        <div :key="index">
                          <template
                            v-for="(reg, index1) in registered_url.linkedin"
                          >
                            <div :key="index1">
                              {{ reg.url }}
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                    <div v-if="accountDescription.satellite_office">
                      <template
                        v-for="(satellite_url,
                        index) in accountDescription.satellite_office"
                      >
                        <div :key="index">
                          <template
                            v-for="(sat, index1) in satellite_url.linkedin"
                          >
                            <div :key="index1">
                              {{ sat.url }}
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </vs-list>
                </div>
              </div>
            </div>
          </div>
          <vs-button
            class="mt-10"
            v-if="accountDescription.length != 0"
            @click="acceptAssociation()"
            >Accept</vs-button
          >
        </vs-popup>
      </template>
    </vx-card>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import JsonExcel from "vue-json-excel";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";

// import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import axios from "@/axios.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    UpdateAccountpopupActive: false,
    campaign_columns: [],
    // json_fields: {
    //     Company: "company_name",
    //     Country: "country",
    //     Title: "title",
    //     Forename: "forename",
    //     Surname: "surname"
    //   },
    selectedCompanyContact: [],
    abilities: null,
    companySearchComponentKey: 0,
    popupActive: false,
    accountDescription: [],
    accounts: [],
    table_name: null,
    log: [],
    selected: [],
    unmatched_contacts: [],
    currentx: 1,
    total: 0,
    dropArg: null,
    dataSource: {},
    unAssociatedContacts: [],
    columnDefs: [
    ]
  }),
  components: {
    "v-select": vSelect,
    AccountAutocomplete,
    downloadExcel: JsonExcel,
    ClientDataGrid
  },
  watch: {
  },
  methods: {
    goToCreateAccountPage() {

      const routeData = this.$router.resolve({name: 'add-accounts'});
      window.open(routeData.href, '_blank');

      // this.$router.push({
      //   name: "create-account"
      // });
    },
    getAllContactSelectedCampaignColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllContactSelectedCampaignColumns",
          self.$route.params.campaignId
        )
        .then(res => {

          // let response_data = res.data.data;

              let selected_columns = JSON.parse(res.data);



              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'contact_status' && ele.identifier != 'contact_status_notes' && ele.identifier != 'grade' 
              });


              selected_columns.forEach(function(ele) {

                ele.field = '_' + ele.uuid.replaceAll("-", "_");
                ele.headerName = ele.name;

                  if (ele.type == "date") {
                    ele.filter = "agDateColumnFilter";
                  } else if (ele.type == "number") {
                    ele.filter = "agNumberColumnFilter";
                  } else {
                    ele.filter = "agTextColumnFilter";
                  }



                ele.flex = 1;
                ele.filterParams = {
                  buttons: ["apply", "reset"],
                  maxNumConditions: 4
                };
              });


            self.columnDefs = selected_columns


            self.columnDefs.push(  {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 90
      }
            );


            self.columnDefs.push(  {
        headerName: "Company Name",
        field: "_ec41e532_632d_4323_8071_f60b4543a68a",
         rowGroup: true,
         hide: true,
        flex: 1,
        filterParams : {
                  buttons: ["apply", "reset"],
                  maxNumConditions: 4
                }
      });

            

        

        })
        .catch(err => {
          console.log(err);
        });
    },
    dropAllUnAssocaitedContacts() {
      axios
        .post(this.$base_url + "/api/contacts/drop_all_unassociated_contacts", {
          campaignId: this.campaignId
        })
        .then(response => {
          console.log("unass" , response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    searchCompany(inputValue) {
      let data = {};
      data.search_term = inputValue;
      data.campaignId = this.campaignId;
      return this.$store
        .dispatch("accountsManagement/getCompanyFromMasterDatabase", data)
        .then(response => {
          if (response) {
            let data = JSON.parse(
              moduleAccountsManagement.state.company_or_registration_no
            );
            if (data) {
              console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].uuid,
                  name: data[property].company_name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    proceedToML(){
      this.dropAllUnAssocaitedContacts()
       this.$router.push({
              name: "import-contact-to-campaign",
              params: { campaignId: this.campaignId }
            });
    },
    associatedContactWithAccount(data) {
      this.companySearchComponentKey += 1;
      this.accountDescription = [];
      this.popupActive = true;
      console.log(data)
      this.selectedCompanyContact = data;
    },
    UpdateAssociatedCompanyNameOfContact(data) {
      console.log("dtatatatata" , data)





      this.companySearchComponentKey += 1;
      this.accountDescription = [];
      this.UpdateAccountpopupActive = true;
      this.selectedCompanyContact = data;
    },
    UpdateacceptAssociation() {
      this.masterDatabaseAccount = this.accountDescription;
      this.udateassociateSelectedAccountContact();
    },
    acceptAssociation() {
      this.popupActive = false;
       this.$vs.dialog({
        title: `Warning`,
        type: "confirm",
        color: "danger",
        text: `You are adding a new account to this campaign. You must have permission from the campaign manager to do this. If you do no t have permission please seek it from the campaign manager. Otherwise please click on cancel button.`,
        accept: this.confirmAcceptAssociation,
        acceptText: "Accept"
      });
    },
    confirmAcceptAssociation() {
      this.masterDatabaseAccount = this.accountDescription;
      this.associateSelectedAccountContact();
    },
    dropUnassociatedContacts(arg) {
      this.dropArg = arg;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Are you sure you want to drop this contact?`,
        accept: this.dropSelectedAccountContact,
        acceptText: "Delete"
      });
    },
    dropUnassociatedContactsWithGroup(company_name) {
      this.dropArg = company_name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Are you sure you want to drop this all contacts of this account?`,
        accept: this.dropUnassociatedContactsWithGroupAccept,
        acceptText: "Delete"
      });
    },

    dropUnassociatedContactsWithGroupAccept() {


 let data = {};
 data.company_name =this.dropArg

//  data.company_name = company_name
 data.campaignId = this.campaignId;
 axios
   .post(
     this.$base_url + "/api/contacts/drop_selected_account_contact_with_group",
     data
   )
   .then(response => {
     if (response.data.status == "success") {
       this.popupActive = false;
       this.getAccountDataSource()

       
       // this.getAssocaitedAccountsContacts();
     }
     this.$vs.loading.close();
   })
   .catch(error => {
     console.log(error);
   });
},

    

    dropSelectedAccountContact() {

     console.log(this.dropArg)

      let data = {};
      data.contact_id = "'" + this.dropArg.ml_id + "'";
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/drop_selected_account_contact",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.popupActive = false;
            this.getAccountDataSource()

            
            // this.getAssocaitedAccountsContacts();
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleChildEvent() {
      this.accountDescription = [];
      this.accountDescription =
        moduleAccountsManagement.state.accounts.datas[0];
    },
    associateSelectedAccountContact() {
      this.$vs.loading();
      let data = {};
      data.master_database_account = this.masterDatabaseAccount;
      data.csv_contact_id = this.selectedCompanyContact.ml_id;
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/associate_selected_account_contact",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.getAccountDataSource()
            this.popupActive = false;

            // this.getAssocaitedAccountsContacts();
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    udateassociateSelectedAccountContact() {
      this.$vs.loading();
      let data = {};
      data.master_database_account = this.masterDatabaseAccount;

      data.company_name = this.selectedCompanyContact;
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/update_associate_selected_account_contact",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.getAccountDataSource()
            this.UpdateAccountpopupActive = false;

            // this.getAssocaitedAccountsContacts();
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAccountDataSource() {
      var self = this;
      self.$vs.loading();

      let data = {};
      data.campaign_id = self.campaignId;
      self.$store
        .dispatch("accountsManagement/getUnassociatedContacts", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);


      
          self.unAssociatedContacts = response_data.row_as_dict;

          self.campaign_columns = response_data.campaign_selected_field;

          self.showDatagrid = true;

          self.$vs.loading.close();

        })
        .catch(err => {
          console.error(err);
        });


    },
    // getDataSource() {
    //   var self = this;
    //   this.dataSource = {
    //     getRows(params) {
    //       const campaignId = self.$route.params.campaignId;
    //       self.$store
    //         .dispatch("campaignsManagement/fetchCampaign", campaignId)
    //         .then(res => {
    //           self.campaignDescription = res.data;
    //           params.request.table_name = 'temp_' + self.campaignDescription["id"].replaceAll("-", "_") + "_contacts";
    //           params.request.campaignId = self.$route.params.campaignId;
    //           self.$store
    //             .dispatch(
    //               "contactsManagement/getUnassociatedContacts",
    //               params.request
    //             )
    //             .then(function(response) {



                     


    //               let response_data = response.rows.row_as_dict;

    //               self.campaign_columns = response.rows.campaign_selected_field;

    //               response_data.forEach(function(element,index) {
    //                 element.unique_id = index;
    //               });

    //               console.log(response_data)
    //               if (response_data.length != 0) {
    //                 self.$refs.unAssociatedContactsGrid.gridApi.hideOverlay();

    //                 params.success({ rowData: response.rows.row_as_dict , rowCount: response.lastRow })
    //               } else {
    //                 self.$refs.unAssociatedContactsGrid.gridApi.showNoRowsOverlay();
    //                 return params.success({ rowData: [] })
    //               }
    //             })
    //             // .then(response =>
    //             //   params.successCallback(response.rows, response.lastRow)
    //             // )
    //             .catch(err => {
    //               console.error(err);
    //             });
    //         })
    //         .catch(err => {
    //           console.error(err);
    //         });
    //     }
    //   };
    // }
  },
  mounted() {
    this.getAllContactSelectedCampaignColumns()
    this.getAccountDataSource();
    // this.getDataSource();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedAccountsContacts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>